import { StudentsResponse } from './Students';

export const FetchWallOfFame = async (page: number, itemsPerPage: number): Promise<StudentsResponse> => {
  try {
    const response = await fetch(`${import.meta.env.VITE_BASE_URL}/wp-json/wall-of-fame/v1/weekly-wall?page=${page}&per_page=${itemsPerPage}`);
    const data: StudentsResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error;
  }
};
